import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { connect, } from 'react-redux';

import QRLogin from "components/Roku/QRLogin/QRLogin"
import styles from 'components/Roku/Welcome/RokuWelcome.module.scss';

import { APP_TYPES } from '../../../constants/AppTypes';
import { pickImage } from "helpers/webpSupport";

// Images (WebP with PNG fallback)
import logoPng from "images/logo-high-res.png";
import logoWebp from "images/logo-high-res.webp";
import robotPng from "images/rokuHeros/tv-robot.png";
import robotWebp from "images/rokuHeros/tv-robot.webp";
import tvBackgroundPng from "images/rokuHeros/tv-background.png";
import tvBackgroundWebp from "images/rokuHeros/tv-background.webp";
import cloudLeftPng from "images/clouds/clouds-qr-screen-left.png";
import cloudLeftWebp from "images/clouds/clouds-qr-screen-left.webp";
import cloudRightPng from "images/clouds/clouds-qr-screen-right.png";
import cloudRightWebp from "images/clouds/clouds-qr-screen-right.webp";

const logo = pickImage(logoWebp, logoPng);
const robot = pickImage(robotWebp, robotPng);
const tvBackground = pickImage(tvBackgroundWebp, tvBackgroundPng);
const cloudLeft = pickImage(cloudLeftWebp, cloudLeftPng);
const cloudRight = pickImage(cloudRightWebp, cloudRightPng);

class RokuWelcome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            enabled: !this.props.auth.isLoggedIn,
            show: true,
        };
    }

    componentDidUpdate(prevProps) {
        if (!this.props.auth.isLoggedIn && prevProps.auth.isLoggedIn) {
            this.setState({ enabled: true, show: true });
        }
    }

    close = (QRSessionID) => {
        if (!this.state.show) return;
        this.setState({ show: false });
        if (["play@game.city", "dev@game.city"].includes(this.props.auth?.user?.email)) {
            window.location.href = `https://ddd.game.city/${[APP_TYPES.FIRE_TV, APP_TYPES.SAMSUNG, APP_TYPES.ROKU].includes(this.props.appType) ? this.props.appType : "roku"}`;
            return;
        }
        else if (["stage@game.city"].includes(this.props.auth?.user?.email)) {
            window.location.href = `https://ssss.game.city/${[APP_TYPES.FIRE_TV, APP_TYPES.SAMSUNG, APP_TYPES.ROKU].includes(this.props.appType) ? this.props.appType : "roku"}`;
            return;
        }
        setTimeout(() => {
            this.setState({ enabled: false });
            this.props.onLogin(QRSessionID);
        }, 600);
    }

    render() {
        return (
            <React.Fragment>
                {this.state.enabled &&
                    <div className={`${styles.screenOverlay} ${this.state.show ? styles.show : ''} ${this.props.styles || ''}`}>
                        <img className={styles.bgImage} src={tvBackground} alt="" />
                        <div className={styles.bgOverlay} />
                        {/* Centered login card */}
                        <div className={styles.card}>
                            <img className={styles.cloudLeft} src={cloudLeft} alt="" />
                            <img className={styles.cloudRight} src={cloudRight} alt="" />
                            <img className={styles.logo} src={logo} alt="Game City" />

                            <p className={styles.title}>Get stuck in!</p>
                            <p className={styles.subtitle}>
                                <strong>Just scan the QR code</strong> on your<br />phone to login and start playing
                            </p>

                            <div className={styles.qrArea}>
                                <div className={styles.qrBox}>
                                    <QRLogin
                                        onLogin={this.close}
                                        appType={this.props.appType}
                                        color="#000000"
                                        expiredMessage={this.props.appType === APP_TYPES.FIRE_TV ?
                                            <>Your session has expired, press <span className={styles.fireTvButton}>&#9776;</span> and refresh.</> :
                                            this.props.appType === APP_TYPES.SAMSUNG ?
                                            <>Your session has expired, press the <span className={styles.fireTvButton}>&#128994;</span> green button to refresh.</> :
                                            "Your session has expired, please restart the app."
                                        }
                                        TTL={this.props.isFireTv ? 300 : 600}
                                    />
                                </div>
                                <img className={styles.robot} src={robot} alt="" />
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

export default connect(mapStateToProps)(withRouter(RokuWelcome));
